/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/tools/Tool',['underscore', '../../lib/@waca/core-client/js/core-client/ui/core/Class', '../DefaultAttributes', 'fabric'], function (_, Class, DefaultAttributes) {
	'use strict';

	/**
  * New Cursor object based on the Line API.
  */

	window.fabric.Cursor = window.fabric.util.createClass(window.fabric.Line, {

		type: 'cursor',

		_render: function _render(ctx) {
			var p = this.calcLinePoints();

			ctx.beginPath();
			ctx.moveTo(p.x1 + 1, p.y1 + 7);
			ctx.lineTo(p.x1 + 1, p.y1 + 1);
			ctx.lineTo(p.x1 + 7, p.y1 + 1);
			ctx.lineTo(p.x1 + 7, p.y1 - 1);
			ctx.lineTo(p.x1 + 1, p.y1 - 1);
			ctx.lineTo(p.x1 + 1, p.y1 - 7);
			ctx.lineTo(p.x1 - 1, p.y1 - 7);
			ctx.lineTo(p.x1 - 1, p.y1 - 1);
			ctx.lineTo(p.x1 - 7, p.y1 - 1);
			ctx.lineTo(p.x1 - 7, p.y1 + 1);
			ctx.lineTo(p.x1 - 1, p.y1 + 1);
			ctx.lineTo(p.x1 - 1, p.y1 + 7);
			ctx.closePath();

			this._renderPaintInOrder(ctx);
		}
	});

	/**
  * Add static method for deserializing the Cursor object.
  */
	window.fabric.Cursor.fromObject = function (object, callback) {
		function _callback(instance) {
			delete instance.points;
			callback && callback(instance);
		}
		var options = _.extend({}, object, true);
		options.points = [object.x1, object.y1, object.x2, object.y2];
		window.fabric.Object._fromObject('Cursor', options, _callback, 'points');
	};

	var Tool = Class.extend({

		borderColor: 'black',
		fillColor: 'transparent',
		COLORS: {
			'red': '#e62325',
			'blue': '#5392ff',
			'green': '#34bc6e',
			'yellow': '#fed500',
			'white': '#ffffff',
			'black': '#000000',
			'none': 'transparent'
		},

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			// eslint-disable-line no-unused-vars
			Tool.inherited('init', this, arguments);
		},

		create: function create(canvas, xCoord, yCoord) {}, // eslint-disable-line no-unused-vars

		onSelectionCreated: function onSelectionCreated(event, canvas) {}, // eslint-disable-line no-unused-vars

		onSelectionUpdated: function onSelectionUpdated(event, canvas) {}, // eslint-disable-line no-unused-vars

		executeAction: function executeAction(action, canvas) {
			this.deactivate(canvas);return false;
		}, // eslint-disable-line no-unused-vars

		activate: function activate(canvas, xCoord, yCoord) {
			canvas.isDrawingMode = false;
			canvas.selection = false;
			canvas.mouseIsDown = false;
			canvas.keyPress = false;
			var cursor = this.newCursor(canvas, xCoord, yCoord);
			canvas.add(cursor);
			canvas.discardActiveObject().renderAll();
			canvas.getObjects().forEach(function (o) {
				o.set({
					selectable: false,
					editable: false,
					hasControls: false
				});
			});
			return cursor;
		},

		deactivate: function deactivate(canvas) {
			canvas.isDrawingMode = false;
			canvas.selection = true;
			canvas.mouseIsDown = false;
			canvas.keyPress = false;
			var elem = -1;
			var obj = canvas.getObjects();
			obj.forEach(function (o, i) {
				if (o.figure === 'cursor') {
					elem = i;
				}
				o.set({
					selectable: true,
					editable: true,
					hasControls: true
				}).setCoords();
			});
			if (elem >= 0) {
				canvas.remove(obj[elem]);
			}
		},

		setColors: function setColors(canvas, colors) {
			// eslint-disable-line no-unused-vars
			this.borderColor = this.COLORS[colors.borderColor];
			this.fillColor = this.COLORS[colors.fillColor];
		},

		canUpdate: function canUpdate() {
			return true;
		},

		newCursor: function newCursor(canvas, xCoord, yCoord) {
			var cursor = new window.fabric.Cursor([xCoord, yCoord + 1, xCoord, yCoord], _.extend({}, DefaultAttributes, {
				stroke: 'white',
				fill: 'black',
				strokeWidth: 1,
				figure: 'cursor'
			}));
			return cursor;
		}

	});

	return Tool;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

